export default __webpack_public_path__ + "static/media/toolbox.d9c2b5c3.svg";